<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-button class="btn-primary" @click="openAddStore">创建门店</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search v-model:value="searchForm.store_name" :loading="searchLoading" placeholder="请输入门店名称" @search="getTableList"> </a-input-search>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.status" placeholder="状态" @change="getTableList()">
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">开业</a-select-option>
            <a-select-option :value="2">停业</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table :columns="columns" :dataSource="dataSource" :loading="searchLoading" :pagination="false" :scroll="{ y: tableHeight }" class="table" size="small">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'operate'">
        <!-- <a-button type="link" @click="updateStatus(record)">关联房间</a-button> -->
        <a-button type="link" @click="openDetails(record, 2)">编辑</a-button>
        <a-button type="link" @click="openDetails(record, 1)">查看</a-button>
        <a-button class="f-c-red" type="link" @click="handleDel(record)">删除 </a-button>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

  <!-- 地图定位 -->
  <map-select
    v-if="visibleMap"
    :latitude="addForm.latitude"
    :longitude="addForm.longitude"
    :showMap="visibleMap"
    @address="
      params => {
        addForm.address = params;
      }
    "
    @close="visibleMap = false"
    @selectValue="selectMap"
  />

  <!-- 门店弹窗 -->
  <a-modal v-model:visible="visibleAdd" :title="formTitle" :width="'80%'" class="modal" @ok="confirmFun">
    <a-form ref="formRef" :label-col="{ span: 8 }" :model="addForm" :rules="rules">
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item v-if="addForm.id" class="f-item" label="门店ID" name="store_name">
            <div v-if="isLook">{{ addForm.id }}</div>
            <a-input v-else v-model:value="addForm.id" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="经营者类型" name="type">
            <div v-if="isLook">{{ addForm.type_text }}</div>
            <a-radio-group v-else v-model:value="addForm.type">
              <a-radio :value="1">企业</a-radio>
              <a-radio :value="2">个人</a-radio>
              <a-radio :value="3">个体户</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="addForm.status" class="f-item" label="经营状态" name="status">
            <div v-if="isLook">{{ addForm.status == 1 ? '开业' : '停业' }}</div>
            <a-radio-group v-else v-model:value="addForm.status">
              <a-radio :value="1">开业</a-radio>
              <a-radio :value="2">停业</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item class="f-item" label="门店名称" name="store_name">
            <div v-if="isLook">{{ addForm.store_name }}</div>
            <a-input v-else v-model:value="addForm.store_name" placeholder="请输入门店名称" />
          </a-form-item>
          <a-form-item class="f-item" label="所属派出所" name="police_station">
            <div v-if="isLook">{{ addForm.police_station }}</div>
            <a-input v-else v-model:value="addForm.police_station" placeholder="请输入所属派出所" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="开业日期" name="company_date">
            <div v-if="isLook">{{ addForm.company_date }}</div>
            <a-date-picker v-else v-model:value="company_date" placeholder="请选择日期" style="width: 100%" @change="updateDateChange1" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="企业名称" name="company_name">
            <div v-if="isLook">{{ addForm.company_name }}</div>
            <a-input v-else v-model:value="addForm.company_name" placeholder="请输入企业名称" />
          </a-form-item>
          <a-form-item class="f-item" label="联系电话" name="company_phone">
            <div v-if="isLook">{{ addForm.company_phone }}</div>
            <a-input v-else v-model:value="addForm.company_phone" placeholder="请输入联系电话" />
          </a-form-item>
          <a-form-item class="f-item" label="楼栋数" name="build_num">
            <div v-if="isLook">{{ addForm.build_num }}</div>
            <a-input-number v-else v-model:value="addForm.build_num" :min="0" placeholder="请输入楼栋数" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="楼层数" name="floor_num">
            <div v-if="isLook">{{ addForm.floor_num }}</div>
            <a-input-number v-else v-model:value="addForm.floor_num" :min="0" placeholder="请输入楼层数" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="房间数" name="house_num">
            <div v-if="isLook">{{ addForm.house_num }}</div>
            <a-input-number v-else v-model:value="addForm.house_num" :min="0" placeholder="请输入房间数" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="床位数" name="bed_num">
            <div v-if="isLook">{{ addForm.bed_num }}</div>
            <a-input-number v-else v-model:value="addForm.bed_num" :min="0" placeholder="请输入床位数" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="门店星级" name="company_star">
            <div v-if="isLook">{{ addForm.company_star }}</div>
            <a-input-number v-else v-model:value="addForm.company_star" :min="0" placeholder="请输入门店星级" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="经营面积(㎡)" name="area">
            <div v-if="isLook">{{ addForm.area }}</div>
            <a-input-number v-else v-model:value="addForm.area" :min="0" placeholder="请输入经营面积" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="导航定位：">
            <div v-if="isLook">经度:{{ addForm.longitude }} , 纬度{{ addForm.latitude }}</div>
            <a-select v-else v-model:value="location" :open="false" placeholder="请选择定位" style="width: 100%" @click="visibleMap = true"></a-select>
          </a-form-item>
          <a-form-item class="f-item" label="所在区域：">
            <div v-if="isLook">{{ addForm.province_name }} / {{ addForm.city_name }} / {{ addForm.area_name }}</div>
            <AreaSelect v-else :class="{ areaSel: addForm.id }" :placeholder="areaPlaceholder" style="width: 100%" @changeArea="changeArea" />
          </a-form-item>
          <a-form-item class="f-item" label="门店地址" name="address">
            <div v-if="isLook">{{ addForm.address }}</div>
            <a-textarea v-else v-model:value="addForm.address" placeholder="请输入门店详细地址" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item v-if="isLook" class="f-item" label="营业执照" name="">
            <div>{{ addForm.type == 1 ? '有' : '无' }}</div>
          </a-form-item>
          <a-form-item class="f-item" label="企业信用代码" name="company_code">
            <div v-if="isLook">{{ addForm.company_code }}</div>
            <a-input-number v-else v-model:value="addForm.company_code" :min="0" placeholder="请输入企业信用代码" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="营业执照注册地址" name="company_address">
            <div v-if="isLook">{{ addForm.company_address }}</div>
            <a-textarea v-else v-model:value="addForm.company_address" placeholder="请输入营业执照注册地址" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="法定代表人姓名" name="company_contact_name">
            <div v-if="isLook">{{ addForm.company_contact_name }}</div>
            <a-input-number v-else v-model:value="addForm.company_contact_name" :min="0" placeholder="请输入法定代表人姓名" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="法定代表人电话" name="company_contact_phone">
            <div v-if="isLook">{{ addForm.company_contact_phone }}</div>
            <a-input-number v-else v-model:value="addForm.company_contact_phone" :min="0" placeholder="请输入法定代表人电话" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="法定代表人身份证" name="company_contact_idcard">
            <div v-if="isLook">{{ addForm.company_contact_idcard }}</div>
            <a-input-number v-else v-model:value="addForm.company_contact_idcard" :min="0" placeholder="请输入法定代表人身份证" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item class="f-item" label="营业执照图片" name="special_fire_cert">
            <div class="image">
              <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="
                  $event => {
                    uploadFinally($event, 'company_image_url');
                  }
                "
              >
                <img v-if="addForm.company_image_url" :src="addForm.company_image_url" alt="图片" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
                <div v-else>
                  <div class="ant-upload-text f-c-999">上传图片</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="法人证件照" name="company_contact_image_url">
            <div class="image">
              <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="
                  $event => {
                    uploadFinally($event, 'company_contact_image_url');
                  }
                "
              >
                <img v-if="addForm.company_contact_image_url" :src="addForm.company_contact_image_url" alt="图片" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
                <div v-else>
                  <div class="ant-upload-text f-c-999">上传图片</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="经营许可证" name="company_license_url">
            <div class="image">
              <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="
                  $event => {
                    uploadFinally($event, 'company_license_url');
                  }
                "
              >
                <img v-if="addForm.company_license_url" :src="addForm.company_license_url" alt="图片" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
                <div v-else>
                  <div class="ant-upload-text f-c-999">上传图片</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item class="f-item" label="是否有特种行业许可证" name="is_special" style="width: 500px !important">
            <div v-if="isLook">{{ addForm.is_special == 1 ? '有' : '无' }}</div>
            <a-radio-group v-else v-model:value="addForm.is_special">
              <a-radio :value="1">有</a-radio>
              <a-radio :value="2">无</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item class="f-item" label="特种行业经营许可证号码" name="special_number" style="width: 500px !important">
            <div v-if="isLook">{{ addForm.special_number }}</div>
            <a-input v-else v-model:value="addForm.special_number" placeholder="请输入许可证号码" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="发证机构" name="special_mechanism">
            <div v-if="isLook">{{ addForm.special_mechanism }}</div>
            <a-input v-else v-model:value="addForm.special_mechanism" placeholder="请输入发证机构" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="发证日期" name="special_date">
            <div v-if="isLook">{{ addForm.special_date }}</div>
            <a-date-picker v-else v-model:value="special_date" placeholder="请选择日期" style="width: 100%" @change="updateDateChange" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="消防验收合格证明" name="special_fire_cert_url">
            <div class="image">
              <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="
                  $event => {
                    uploadFinally($event, 'special_fire_cert_url');
                  }
                "
              >
                <img v-if="addForm.special_fire_cert_url" :src="addForm.special_fire_cert_url" alt="图片" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
                <div v-else>
                  <div class="ant-upload-text f-c-999">上传图片</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item class="f-item" label="企业负责人姓名" name="user_name">
            <div v-if="isLook">{{ addForm.user_name }}</div>
            <a-input v-else v-model:value="addForm.user_name" placeholder="请输入企业负责人姓名" />
          </a-form-item>
          <a-form-item class="f-item" label="保卫负责人姓名" name="security_name">
            <div v-if="isLook">{{ addForm.security_name }}</div>
            <a-input v-else v-model:value="addForm.security_name" placeholder="请输入保卫负责人姓名" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="企业负责人电话" name="phone">
            <div v-if="isLook">{{ addForm.phone }}</div>
            <a-input v-else v-model:value="addForm.phone" placeholder="请输入企业负责人电话" />
          </a-form-item>
          <a-form-item class="f-item" label="保卫负责人电话" name="security_phone">
            <div v-if="isLook">{{ addForm.security_phone }}</div>
            <a-input v-else v-model:value="addForm.security_phone" placeholder="请输入保卫负责人电话" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="企业负责人身份证" name="id_card">
            <div v-if="isLook">{{ addForm.id_card }}</div>
            <a-input v-else v-model:value="addForm.id_card" placeholder="请输入企业负责人身份证" />
          </a-form-item>
          <a-form-item class="f-item" label="保卫负责人身份证" name="security_idcard">
            <div v-if="isLook">{{ addForm.security_idcard }}</div>
            <a-input v-else v-model:value="addForm.security_idcard" placeholder="请输入保卫负责人身份证" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>

  <!-- 加入分组 -->
  <a-modal v-model:visible="visibleJoin" title="加入分组" @ok="handleJoinSave">
    <a-form-item label="分组：">
      <a-select v-model:value="joinGroup" :filterOption="groupFilter" allowClear mode="multiple" placeholder="请选择分组">
        <a-select-option v-for="(item, index) in GroupList" :key="index" :value="item.id">{{ item.name }} </a-select-option>
      </a-select>
    </a-form-item>
  </a-modal>
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { storeAdd, storeDel, storeDetails, storeEdit, storeList } from '@/api/api';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import AreaSelect from '@/components/pms/landlord/AreaSelect/AreaSelect.vue';
import MapSelect from '@/components/pms/landlord/MapSelect/MapSelect.vue';
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';
import { mapKey, baseRequestUrl } from '../../../../config.js';

export default {
  components: {
    // PlusOutlined,
    // CloseCircleOutlined,
    AreaSelect,
    MapSelect,
  },
  setup() {
    let { imgCut, countTable } = useUtils();

    // 地图
    const mapselect = reactive({
      visibleMap: false,
      location: [],
      src: 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=' + mapKey + '&referer=平台',
      selectMap(params) {
        modal.addForm.longitude = params.longitude;
        modal.addForm.latitude = params.latitude;
        mapselect.location = '经度：' + `${params.latitude}` + '；纬度：' + `${params.longitude}`;
        modal.formRef.validate('latitude');
      },
    });

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        store_name: '',
        status: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      // 重置
      handleReset() {
        search.searchForm.store_name = '';
        search.searchForm.status = [];
        table.getTableList();
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      tableHeight: '',
      dataSource: [],
      columns: [
        {
          title: '门店ID',
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: '门店名称',
          dataIndex: 'store_name',
          key: 'store_name',
          width: 150,
        },
        {
          title: '房间数',
          dataIndex: 'house_num',
          key: 'house_num',
          width: 100,
        },
        {
          title: '联系人',
          dataIndex: 'user_name',
          key: 'user_name',
          customRender({ record }) {
            return record.user_name + '_' + record.phone;
          },
          width: 200,
        },
        {
          title: '地址',
          dataIndex: 'address',
          key: 'address',
          customRender({ record }) {
            return record.province_name + record.city_name + record.area_name + record.address;
          },
          ellipsis: true,
          width: 300,
        },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
          width: 100,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 150,
        },
        {
          title: '操作',
          dataIndex: 'operate',
          key: 'operate',
          width: 200,
          align: 'center',
        },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        storeList({
          store_name: search.searchForm.store_name,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          status: search.searchForm.status.toString(),
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { hid: params.id, tab: tab } });
      },
    });

    // 弹窗
    let modal = reactive({
      areaPlaceholder: '请选择区域',
      formTitle: '添加门店',
      visibleRoom: false,
      visibleAdd: false,
      visibleJoin: false,
      CompanyOta: [],
      loading: false,
      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },

      isLook: false,

      //  上传图片
      uploadFinally(info, key) {
        if (info.file.status === 'done') {
          modal.addForm[key] = info.file.response.data.url;
        }
      },
      getInitData() {
        return {
          type: 1,
          is_security: 1,
          store_name: '',
          user_name: '',
          id_card: '',
          phone: '',
          province_id: '',
          city_id: '',
          area_id: '',
          province_name: '',
          city_name: '',
          area_name: '',
          address: '',
          longitude: '',
          latitude: '',
          house_num: '',
          company_name: '',
          company_code: '',
          company_address: '',
          company_contact_name: '',
          company_contact_phone: '',
          company_contact_idcard: '',
          security_name: '',
          security_idcard: '',
          security_phone: '',
          company_date: '',
          company_star: '',
          area: '',
          build_num: '',
          floor_num: '',
          bed_num: '',
          is_special: 1,
          special_number: '',
          special_mechanism: '',
          special_date: '',
          special_fire_cert: '',
          police_station: '',
          company_image_url: '',
          special_fire_cert_url: '',
          company_contact_image_url: '',
          company_license_url: '',
          company_phone: '',
          id: '',
        };
      },
      special_date: '',
      company_date: '',
      updateDateChange(_, dateString) {
        modal.addForm.special_date = dateString;
      },
      updateDateChange1(_, dateString) {
        modal.addForm.company_date = dateString;
      },

      // 打开添加门店
      openAddStore() {
        modal.isLook = false;
        mapselect.location = [];
        modal.areaPlaceholder = '请选择区域';
        modal.formTitle = '添加门店';
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
      },
      // 查看门店
      openDetails(e, type) {
        if (type == 1) {
          modal.isLook = true;
          modal.formTitle = '查看门店';
        } else {
          modal.isLook = false;
          modal.formTitle = '编辑门店';
        }
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
        storeDetails({
          id: e.id,
        }).then(res => {
          Object.keys(modal.addForm).forEach(i => {
            modal.addForm[i] = res.data[i];
          });
          modal.addForm.id = res.data.id;
          modal.addForm.status = res.data.status;
          modal.addForm.type_text = res.data.type_text;
          modal.areaPlaceholder = res.data.province_name + ' / ' + res.data.city_name + ' / ' + res.data.area_name;
          mapselect.location = '经度：' + `${res.data.latitude}` + '；纬度：' + `${res.data.longitude}`;
        });
      },
      rowData: '',
      addForm: {},
      formRef: '', //表单验证

      // 打开地图
      handleOpenMap() {
        mapselect.visibleMap = true;
      },
      modalLoading: false,
      //确定
      confirmFun() {
        if (modal.addForm.id && modal.addForm.id > 0) {
          modal.handleEditSave();
        } else {
          modal.handleAddSave();
        }
      },
      // 新增
      handleAddSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          storeAdd(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              mapselect.location = '';
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
      //编辑
      handleEditSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          storeEdit(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              mapselect.location = '';
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
      // 选择区域回调
      changeArea(params) {
        Object.assign(modal.addForm, params);
      },

      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: '确定删除门店吗？',
          content: '如果您入住登记需要上报公安系统，删除后将影响相关的房源数据上报，请谨慎操作',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            storeDel({ id: item.id }).then(res => {
              message.success(res.msg);
              table.getTableList();
            });
          },
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 10;
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(mapselect),
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.row-box {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;

  .f-item {
    margin-bottom: 10px !important;
  }
}

:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}
</style>
